<template>
  <div>
    <g-master name="coc"
              :endpoint="groupMaster.endpoint"
              :tableSetup="groupMaster.tableSetup"
              :modalFieldsSetup="groupMaster.modalFieldsSetup"
              @params="paramsTable"
    >
      <template slot="customButton">
        <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
      </template>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">

          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Descripción: ">
              <a-input
                v-decorator="['group_desc', { rules: [{ required: false}] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="ID grupo: ">
              <a-input
                v-decorator="['group_id', { rules: [{ required: false}] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Conceptos" key="1">
          <gruposdetail v-if="groupID" :group_id="groupID"></gruposdetail>
          <span v-else>Seleccione un cargo para visualizar la logística del cargo.</span>
        </a-tab-pane>
      </a-tabs>
  </div>
</template>

<script>
  export default {

    data () {
      return {
        paramsT: {},
        endpointExcel: 'group_master/downloadExcel',
        fileNameExcel: 'Grupos',
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        groupMaster: {
          endpoint: 'groupmaster',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'group_id'
            },
            columns: [
              {title: 'ID', dataIndex: 'group_id', sorter: true},
              {title: 'Descripción', dataIndex: 'group_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'group_desc'}
          ]
        }
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      groupID () {
        return this.groupMaster.tableSetup.selectedRows.length > 0 ? this.groupMaster.tableSetup.selectedRows[0].group_id : null
      },
      paramsExcel () {
        return {
          ...this.paramsT,
          columns: this.groupMaster.tableSetup.columns
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Coc/MasterGroups.vue